import React, { FC } from "react";
import { View, Text, StyleSheet } from "react-native";
import StyledIcon from "../StyledIcon";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import { formatCurrency } from "../../utils/money";
import AsyncStorage from "@react-native-async-storage/async-storage";
import useMounted from "../../hooks/useMounted";

export const TransactionFeeNotice: FC<any> = () => {
  const isMounted = useMounted();
  const [amount, setAmount] = React.useState<any>(null);

  React.useEffect(() => {
    (async () => {
      const amt = await AsyncStorage.getItem("tranx_fee");
      isMounted && setAmount(amt);
    })();
    return () => {};
  }, []);

  return (
    <>
      {amount && (
        <View style={styles.main}>
          <View style={styles.container}>
            <StyledIcon
              iconName="exclamation"
              iconColor={Colors.whiteColor}
              iconLibrary="MaterialCommunityIcons"
              fillColor={Colors.successText}
            />
            <View style={styles.content}>
              {/* <Text style={styles.heading}>{JSON.stringify(amount)}</Text> */}
              {/* Transfer to save N200 transaction fee. <DA account details></DA> */}
              <Text style={styles.body}>
                Transfer to save{` `}
                <Text style={styles.emphasis}>{formatCurrency(amount)}</Text>
                {` `}transaction fee.
              </Text>
            </View>
          </View>
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  main: {
    padding: 16,
    backgroundColor: Colors.whiteColor,
  },
  container: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.successText,
    borderStyle: "solid",
    backgroundColor: Colors.successBackground,
    flexDirection: "row",
    padding: 12,
  },
  content: {
    flex: 1,
    flexGrow: 1,
    flexDirection: "column",
    paddingLeft: 8,
  },
  heading: {
    ...FontStyles.semibold,
    ...FontStyles.size14,
    ...FontStyles.lh18,
    ...FontStyles.dark,
  },
  body: {
    ...FontStyles.normal,
    ...FontStyles.size14,
    ...FontStyles.lh22,
    ...FontStyles.dark,
  },
  emphasis: {
    ...FontStyles.bold,
    color: Colors.successText,
    marginHorizontal: 4,
    flex: 1,
  },
  actionContainer: {
    flexDirection: "row",
    marginTop: 10,
    justifyContent: "space-between",
  },
});
